import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { CCA_REQUEST_SLACK_NOTIFICATION_MUTATION } from './requestSlackNotification.mutation';
import {
  CcaRequestGenerationJobSlackNotificationMutation,
  CcaRequestGenerationJobSlackNotificationMutationVariables
} from './__generated__/CcaRequestGenerationJobSlackNotificationMutation';

export const useRequestCcaGenerationJobSlackNotification = () => {
  return useMutation<
    CcaRequestGenerationJobSlackNotificationMutation,
    CcaRequestGenerationJobSlackNotificationMutationVariables
  >(CCA_REQUEST_SLACK_NOTIFICATION_MUTATION, { client: kmsClient });
};
